import React from 'react'
import { LANDING_ANIMATION } from '@/components/composed/landingBlocks/LandingAnimation/constants'
import { LandingAnimation } from '../../../../components/composed/landingBlocks/LandingAnimation'
import { formatHighlightedText } from '../../../../components/ui/HighlightedText'
import { AdvancePaymentCalculatorForm } from './components/AdvancePaymentCalculatorForm'
import { AdvancePaymentCalculatorFormula } from './components/AdvancePaymentCalculatorFormula'
import { AdvancePaymentCalculatorResult } from './components/AdvancePaymentCalculatorResult'
import { useAdvancePaymentCalculatorElevators } from './hooks/useAdvancePaymentCalculatorElevators'
import { useAdvancePaymentCalculatorForm } from './hooks/useAdvancePaymentCalculatorForm/useAdvancePaymentCalculatorForm'
import { EAdvancePaymentCalculatorAnimationDelay } from './constants'
import { messages } from './messages'
import type { TAdvancePaymentCalculatorProps } from './types'
import './styles.scss'

const AdvancePaymentCalculator: React.FC<TAdvancePaymentCalculatorProps> = ({ onClickSubmitApplication }) => {
  const { deliveryVolume, daysUntilHarvestDelivery, form, isCalculating, handleSubmit } = useAdvancePaymentCalculatorForm()
  const { data, refetch } = useAdvancePaymentCalculatorElevators({ enabled: false })

  const handleOpenElevatorDropdown = () => {
    if (!data) {
      refetch()
    }
  }

  return (
    <section className="advancePaymentCalculator">
      <div className="advancePaymentCalculator__wrapper page-wrapper">
        <LandingAnimation desktopTargetStyles={{ ...LANDING_ANIMATION.fadeUp, delay: EAdvancePaymentCalculatorAnimationDelay.TITLE }}>
          <h2>{formatHighlightedText(messages.title)}</h2>
        </LandingAnimation>
        <LandingAnimation desktopTargetStyles={{ ...LANDING_ANIMATION.fadeUp, delay: EAdvancePaymentCalculatorAnimationDelay.FORM }}>
          <div className="advancePaymentCalculator__content">
            <AdvancePaymentCalculatorForm
              className="advancePaymentCalculator__form"
              elevators={data}
              form={form}
              daysUntilHarvestDelivery={daysUntilHarvestDelivery}
              onSubmit={handleSubmit}
              onOpenElevatorDropdown={handleOpenElevatorDropdown}
            />
            <AdvancePaymentCalculatorResult
              isLoading={isCalculating}
              className="advancePaymentCalculator__result"
              deliveryVolume={deliveryVolume}
              onClickSubmitApplication={onClickSubmitApplication}
            />
            <AdvancePaymentCalculatorFormula className="advancePaymentCalculator__formula" />
            <div className="advancePaymentCalculator__warning text_super-small">
              <span>{messages.warning.sign}</span>
              <span>{messages.warning.text}</span>
            </div>
          </div>
        </LandingAnimation>
      </div>
    </section>
  )
}

export default AdvancePaymentCalculator
